module.exports = function() {
  return new Worker(__webpack_public_path__ + "cd75319fb98aaa3c23bd.worker.js");
};